var _rect, _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFtxTrChip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 15,
    viewBox: "0 0 43 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 15,
    rx: 2,
    fill: "#F4F5FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14232_49931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8321 7.2964V8.2405H20.0413V9.17846H17.8321V10.6504H16.4164V6.35782H20.3416V7.2964H17.8321Z",
    fill: "#131112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3934 7.32092H20.8562V6.35782H25.3391V7.32092H23.8091V10.6504H22.3934V7.32092Z",
    fill: "#131112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0995 10.6504L28.0628 9.31946L27.0404 10.6504H25.4246L27.2478 8.47959L25.5033 6.35782H27.0976L28.0986 7.5968L29.0852 6.35782H30.6153L28.8707 8.43054L30.7297 10.6504H29.0995",
    fill: "#131112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62769 11.5796H9.76357V9.74841H7.62769V11.5796Z",
    fill: "#84D6D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6586 7.21704H7.62769V9.04883H11.6586H12.3916V7.21765H11.6586V7.21704",
    fill: "#33BBC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62769 4.68787V6.51904H14.2441V4.68787H7.62769",
    fill: "#11A9BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9.04883H7.13517V7.21704H5V9.04883Z",
    fill: "#33BBC7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1585 6.71766H31.6487V6.41064H34.9766V6.71766H33.4668V10.7181H33.1585V6.71766V6.71766Z",
    fill: "#1D1D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7495 9.06893L38.8835 10.7181H38.5196L37.3982 9.08777H36.0485V10.7181H35.7402V6.41064H37.5028C38.3655 6.41064 39.0001 6.96257 39.0001 7.74615C39.0001 8.45438 38.4831 8.97525 37.7495 9.06893ZM36.0485 8.78075H37.4412C38.1743 8.78075 38.6858 8.36681 38.6858 7.74615C38.6858 7.1255 38.1743 6.71817 37.4412 6.71817H36.0485V8.78075Z",
    fill: "#1D1D1B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14232_49931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.7297,
    height: 6.89189,
    fill: "white",
    transform: "translate(5 4.6875)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtxTrChip);
export default __webpack_public_path__ + "static/media/ftxTr_chip.082364a4e688e880df22ab5de1ea04d4.svg";
export { ForwardRef as ReactComponent };